// The billing nudge renders outside the billing page, which strips `charge_id`
// once it arms its wait, so the wait is kept per tab in sessionStorage and
// expires on its own. Unavailable storage costs only the nudge suppression.
const STORAGE_KEY = "billing-2026:approval-return:in-flight";

type InFlightApprovalReturn = Readonly<{ orgId: string; expiresAt: number }>;

const isInFlightApprovalReturn = (
  value: unknown
): value is InFlightApprovalReturn => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const { orgId, expiresAt } = value as Record<string, unknown>;
  return typeof orgId === "string" && typeof expiresAt === "number";
};

export const markShopifyApprovalReturnInFlight = (
  inFlight: InFlightApprovalReturn
): void => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(inFlight));
  } catch {
    return;
  }
};

export const clearShopifyApprovalReturnInFlight = (): void => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
};

export const shopifyApprovalReturnInFlightUntil = (
  orgId: string | undefined,
  nowMs: number = Date.now()
): number | null => {
  if (!orgId) {
    return null;
  }
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw === null ? null : JSON.parse(raw);
    return isInFlightApprovalReturn(parsed) &&
      parsed.orgId === orgId &&
      parsed.expiresAt > nowMs
      ? parsed.expiresAt
      : null;
  } catch {
    return null;
  }
};
